import InviteCreatorsForm from 'features/briefs/components/organisms/InviteCreators/InviteCreatorsForm';

export default InviteCreatorsForm;
